// @ts-ignore
import type { DataTables } from "datatables.net";

import { IVariantsTable } from "../types/variantsTable";
import * as rendering from "./rendering";

declare var SlimSelect: any;


class VariantsTable implements IVariantsTable {
    dataTable: DataTables.Api = undefined;
    filters: Map<string, Array<string>> | undefined = undefined;
    table: DataTables.Api = undefined;
    slimSelects: Array<any> = [];
    suppressSelectChange = false;

    constructor(selector: string, options: object, filters: object | undefined) {
        let self: VariantsTable = this;
        let default_options: object = {
            initComplete: function () { return self.initComplete(this) },
            orderCellsTop: true
        };
        if (filters !== undefined) {
            this.filters = new Map<string, Array<string>>(Object.entries(filters));
        }
        this.dataTable = $(selector).DataTable({ ...default_options, ...options });
    }

    disableSelectChange = () => {
        this.suppressSelectChange = true;
    }

    enableSelectChange = () => {
        this.suppressSelectChange = false;
    }

    createAllFilters = () => {
        let self = this;
        this.dataTable.columns().every((columnIndex: number) => {
            let column: DataTables.Api = this.dataTable.columns().column(columnIndex);
            let cell = $(`.table-filters th:eq(${columnIndex})`);
            let fieldType: string = cell.data("type");
            if (fieldType !== undefined) {
                fieldType = fieldType.trim().toLowerCase();
                const fieldCode = cell.data("code");
                switch (fieldType) {
                    case "text":
                        break;
                    default:
                        self.slimSelects.forEach(function (slimSelect) {
                            if (slimSelect.select.element.getAttribute("data-field-code") === fieldCode) {
                                self.createFilters(cell, column, [], slimSelect);
                            }
                        });
                }
            }
        });
    }

    createFilters = (
        cell: any,
        column: any,
        defaults: Array<string|number> | undefined,
        slimSelect: any
    ) => {

        let fieldType = cell.data("type").trim().toLowerCase();

        slimSelect.setData([]);

        switch (fieldType) {
            case "text":
                break;
            case "metric":
                column.data()
                    .unique()
                    .sort((x: number, y: number) => x - y)
                    .each(function (value: any) {
                        slimSelect.addData({text:value});
                    });
                    slimSelect.setSelected(defaults ?? "");
                break;
            default:
                let data: Array<string> = [];
                let columnData: DataTables.Api = column.data();

                let columnNodes = column.nodes();
                if (columnNodes.length > 0 && $(columnNodes[0]).attr("data-sort")) {
                    columnData = [];
                    columnNodes.each(function (td: any) {
                        let value = $(td).text().trim() ? $(td).text().trim() : $(td).html().trim();
                        try {
                            if ($(value).attr("id") !== undefined) {
                                let subValue = $(value).val();
                                value = subValue !== undefined ? subValue.toString() : $(value).text().trim();
                            }
                        } catch {
                        }
                        columnData.push({
                            value: value,
                            sort: $(td).attr('data-sort')?.replace(/\D/g, '') ?? '-1'
                        });
                    });
                }

                if (columnData.length > 0 && columnData[0].hasOwnProperty("value")) {
                    columnData = columnData.sort((x: any, y: any) => parseInt(x.sort) - parseInt(y.sort));
                    columnData = columnData.map((item: any) => item.value);
                    data = [...new Set<string>(columnData)];
                } else {
                    let values: Array<string> = []
                    columnData.each((item: any) => {
                        try {
                            let dataId = $(item).attr("id");
                            if (dataId !== undefined && $(`#${dataId}`).val() !== undefined) {
                                values.push($(`#${dataId}`).val()?.toString() ?? "");
                            } else if ($(item).val() !== undefined) {
                                values.push($(item).val());
                            } else {
                                values.push(item);
                            }
                        } catch {
                            values.push(item);
                        }
                    });
                    data = [...new Set(values)].sort();
                }

                //data = data.map(item => rendering.escapeHtml(item));
                data.forEach((value: string) => {
                    slimSelect.addData({text:value});
                });
                slimSelect.setSelected(defaults ?? "");
        }
    }

    cleanAllFilters = () => {
        this.disableSelectChange();
        this.dataTable.columns().every((columnIndex: number) => {
            let column: DataTables.Api = this.dataTable.columns().column(columnIndex);
            let cell = $(`.table-filters th:eq(${columnIndex})`);
            if (cell.data("type") === undefined) {
                return;
            }
            let fieldType = cell.data("type").trim().toLowerCase();
            switch (fieldType) {
                case "text":
                    cell.find('input').val('');
                    column.search('').draw();
                    break;
                default:
                    column.search('', false, false).draw();
                    break;
            }
        });
        this.slimSelects.forEach(function (sl) {
            sl.setSelected([]);
        });
        this.enableSelectChange();
        this.dataTable.search('').draw();
    }

    selectChangeFilter = (column: any, item: any) => {
        if (!this.suppressSelectChange) {
            const value = $(item).val();
            if (Array.isArray(value) && value.length) {
                const escaped = value.map(
                    x => $.fn.dataTable.util.escapeRegex(x)
                );
                const pattern = escaped.join("|");
                column
                    .search(`^(${pattern})$`, true, false, false)
                    .draw();
            } else if (typeof value === "string" && value) {
                const escaped = $.fn.dataTable.util.escapeRegex(value);
                column
                    .search(`^${escaped}$`, true, false, false)
                    .draw();
            } else {
                column.search('', false, false).draw();
            }
        }
    }

    initComplete = (table: DataTables.Api) => {
        this.table = table; // Used for calling initComplete() during updates

        let self: VariantsTable = this;
        table.api().columns().every((columnIndex: number) => {
            let column: DataTables.Api = table.api().columns().column(columnIndex);
            let cell: DataTables.Api = table.find(`.table-filters th:eq(${column.index()})`).empty();
            if (cell.data("type") === undefined) {
                return;
            }
            let fieldType: string = cell.data("type").trim().toLowerCase();
            let fieldCode: string | undefined = cell.data("code");
            let fieldId: string = fieldCode ? `var-field-${fieldCode}` : Math.random().toString(36).slice(2, 9);
            if (fieldCode !== undefined) {
                fieldCode = String(fieldCode).trim().toLowerCase();
            }

            let select;
            let defaults: Array<string|number> | undefined;
            if (self.filters === undefined) {
                select = `<select id="${fieldId}" data-field-code="${fieldCode}"><option value=""></option></select>`;
            } else {
                select = `<select class="comboselect" id="${fieldId}" data-field-code="${fieldCode}"><option data-placeholder="true"></option></select>`;
                if (fieldCode !== undefined) {
                    defaults = self.filters.get(fieldCode);
                }
            }

            switch (fieldType) {
                case "text":
                    let inputText = $('<input class="mb0" type="text" />')
                        .appendTo(cell)
                        .on("keyup change clear", function () {
                            column.search($(this).val()).draw();
                        });
                    if (fieldCode) {
                        inputText.val(fieldCode);
                        inputText.trigger("change");
                    }
                    break;
                default:
                    let element = $(select);
                    element
                        .appendTo(cell)
                        .on('change', function () {
                            self.selectChangeFilter(column, this);
                        });
                    let sl = new SlimSelect({
                        select: element[0],
                        allowDeselect: true
                    });
                    self.createFilters(cell, column, defaults, sl);
                    self.slimSelects.push(sl);
            }
        });

        $("#variants").removeClass("hide");
        $("#variants-overlay").addClass("hide");
    }
}

export { VariantsTable };
